export const BUILD_ORDER = {
    BULK_ORDER_ORGANIZER: "bulk-order-organizer",
    OPERATION_COPY: "operation-copy",
    OPERATION_MOVE: "operation-move",
    BUYER_SELECTED_DELIVERIES: "buyer-selected-deliveries",
    NON_BUYER_SELECTED_DELIVERIES: "non-buyer-selected-deliveries",
    IGNORE_UNITS: "ignore-units",
    PRODUCT_PREVIEW: "product-preview",
};
